import LedgerBase from './Base.js';
import { LedgerDerivationPathType } from '../../types.js';
export class LedgerLive extends LedgerBase {
    constructor(args) {
        super({
            ...args,
            derivationPathType: LedgerDerivationPathType.LedgerLive,
        });
    }
}
